import {createRoot} from 'react-dom/client';
import ApolloProvider from 'src/ApolloProvider';
import App from 'src/App';
import LinkTag from 'src/LinkTag';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}
const root = createRoot(rootElement);

// Auth is session-based (BFF): the server owns the OAuth flow with Auth0 and
// keeps the identity in an httpOnly cookie, so there is no client-side auth
// provider — AuthenticationRequired just probes /api/auth/me and redirects
// to the server's /login route when the session is missing.
root.render(
  <ApolloProvider>
    <LinkTag rel="stylesheet" href="index.css" />
    <App />
    <LinkTag
      rel="stylesheet"
      href="https://fonts.googleapis.com/css2?family=Ubuntu&family=Ubuntu+Mono&display=swap"
    />
  </ApolloProvider>,
);
